<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" type="radio" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="退款单号" name="refund_number"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="收货人" name="receiving_name"></c-form-item>
					<c-form-item type="input" label="下单用户电话" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" label="退款单状态" name="state" :options="refundState"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button @click="refundVerifyHandle('resolve')">批量同意申请</c-button>
				<c-button @click="refundVerifyHandle('reject')">批量驳回</c-button>
			</m-operate>
			
			<c-table ref="table" >
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="85"
				>
					<template v-slot="{data}">
						<span style="color:#182eff" v-if="data.state==1">{{orderStateName[data.state]}}</span>
						<span style="color:darkgreen" v-if="data.state==2">{{orderStateName[data.state]}}</span>
						<span style="color:gray" v-if="data.state==3">{{orderStateName[data.state]}}</span>
						<span style="color:gray" v-if="data.state==4">{{orderStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="退款单号"
					name="refund_number"
					width="130"
				></c-table-column>

				<c-table-column
					label="退款类型"
					name="refund_type"
					width="80"
				>
				  <template v-slot="{data}">
					<span v-if="data.refund_type==1" style="color:#888888">{{refundTypeName[data.refund_type]}}</span>
					<span v-if="data.refund_type==2" style="color:#ff00ff">{{refundTypeName[data.refund_type]}}</span>
					<span v-if="data.refund_type==3" style="color:#000000">{{refundTypeName[data.refund_type]}}</span>
				  </template>
				</c-table-column>
		
				<c-table-column
					label="运营模式"
					name="operation_mode"
					width="80"
					v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" 
				>
					<template v-slot="{data}">
						{{orderTypeName[data.operation_mode]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="商家角色"
					name="stationed_auth_name"
					width="120"
					v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'" 
				>
				</c-table-column>
				
				<c-table-column
					label="商家名称"
					name="stationed_name"
					width="150"
					v-if="systemConfig.pt_mode == 2" 
				></c-table-column>
				
				<c-table-column
					label="订单号"
					name="order_number"
				  width="120"
				></c-table-column>
				
				<c-table-column
					label="推送状态"
					name="push_state"
					width="80"
					v-if="systemConfig.order_push_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.push_state==0"><span style="color:#bbbbbb">无需推送</span></span>
						<span v-if="data.push_state==1"><span style="color:#182eff">待推送</span></span>
						<span v-if="data.push_state==2"><span style="color:darkgreen">已推送</span></span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="售后三方单号"
					name="out_refund_number"
					width="140"
					v-if="systemConfig.order_push_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.push_state==0">--</span>
						<span v-if="data.push_state==1">--</span>
						<span v-if="data.push_state==2">{{data.out_refund_number}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="下单用户"
					name="nick_name"
					width="200"
				>
					  <template v-slot="{data}">
						<span>{{data.user_manage_mobilephone}}</span>
						<span v-if="data.nick_name && data.nick_name!=''">({{data.nick_name}})</span>
					  </template>
				</c-table-column>
		
				<c-table-column
					label="收件人"
					name="receiving_name"
				  width="120"
				></c-table-column>
		
				<c-table-column
					label="商品数量"
					name="product_count"
				  width="80"
				></c-table-column>
				
				<c-table-column
					label="商品退款"
					name="product_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.product_money&&data.product_money>0">￥{{data.product_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="运费退款"
					name="logistics_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.logistics_money&&data.logistics_money>0">￥{{data.logistics_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<!-- <c-table-column
					label="服务费退款"
					name="other_fee"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.other_fee&&data.other_fee>0">￥{{data.other_fee.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column> -->
				
				<c-table-column
					label="退款总额"
					name="refund_total_money"
				>
				  <template v-slot="{data}">
					<span style="color:blue" v-if="data.refund_total_money&&data.refund_total_money>0">￥{{data.refund_total_money.toFixed(2)}}</span>
					<span v-else>--</span>
				  </template>
				</c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
				  width="150"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo({path: `/refund_detail/${data.refund_number}`, query: {refundType: data.refund_type}})">查看</c-table-button>
						<c-table-button v-if="data.state == 1" @click="refundVerifyHandle('resolve', data.refund_number)">同意申请</c-table-button>
						<c-table-button v-if="data.state == 1" @click="refundVerifyHandle('reject', data.refund_number)">驳回</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
		
		<c-dialog ref="rejectReason" :title="'驳回原因'+(afterSalesNumber?('-'+afterSalesNumber):'')" width="550" button-name="确认驳回" @resolve="rejectHandle">
			<div class="refund-verify">
				<textarea v-model="rejectReason" placeholder="请输入驳回原因..."></textarea>
			</div>
		</c-dialog>
		
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	export default {
		name: 'm_order_refund',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},
		
        props: {
            state: String,
            refund_state: String,

        },

		data() {
			return {
				afterSalesNumber:'',
				orderStateName: {
					1: '待审核',
					2: '审核通过',
					3: '已驳回',
					4: '已撤销'
				},
				orderTypeName: {
					1: '平台自营',
					2: '商家自营'
				},
				operationMode: [{
						name: '平台自营',
						value: 1
					},{
						name: '商家运营',
						value: 2
					}
				],
				refundState: [{
						name: '待审核',
						value: 1
					},{
						name: '审核通过',
						value: 2
					},{
						name: '已驳回',
						value: 3
					},{
						name: '已撤销',
						value: 4
					}
				],
				refundTypeName: {
				  1: '整单取消',
				  2: '未发退款',
				  3: '定金退款'
				},
				rejectReason: '',
			}
		},

        computed: {
			...mapState(['systemConfig']),
			
            defaultSearch() {
                let param = {
                    state: this.state ? this.state.split(',') : [],
                }

                if (this.refund_state == 1) {
                    param.start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
                    param.end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },
		
		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
			this.$bus.$on('refund.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/refund/list',
					data
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
			
			refundVerifyHandle(type, refund_number, confirm) {
				var list = refund_number ? [{
					data:
						{refund_number: refund_number}
				}] : this.$refs.table.getRow('selected');
				if (!list.length) {
					this.$message({
						text: '请选择要操作的单据'
					});
					return;
				}
				this.afterSalesNumber = refund_number;
				this.selectList = Array.from(list, item => item.data.refund_number);
				
				if (type == 'resolve') {
					var con_msg = refund_number? '确定要对退款单【'+this.afterSalesNumber+'】立即执行退款操作吗？':'确定要对【'+this.selectList.length+'】个退款单（待审批）立即执行退款操作吗？';
					this.afterSalesNumber = refund_number;
					this.$confirm({
						text: con_msg,
						resolve: () => {
							this.request({
								url: '/refund/batch/approval',
								data: {
									refund_numbers: this.selectList
								},
								loading: true,
								success: (data, msg) => {
									this.$message({
										text: msg,
										icon: 'success'
									});
									this.$refs.table.update();
								}
							});
						}
					});
				} else if (confirm) {
					this.request({
						url: '/refund/batch/reject',
						data: {
							refund_numbers: this.selectList,
							refund_reject_reason: this.rejectReason.trim()
						},
						loading: true,
						success: (data, msg) => {
							this.$message({
								text: msg,
								icon: 'success'
							});
							this.$refs.table.update();
						}
					});
				} else {
					this.rejectHandle();
				}
			},
			
			rejectHandle(stop) {
				if (!stop) {
					this.rejectReason = '';
					this.$refs.rejectReason.open();
				} else {
					stop();
						
					if (!this.rejectReason.trim()) {
						this.$message({
							text: '请填写驳回原因'
						});
						return;
					}
					
					this.refundVerifyHandle('reject', this.afterSalesNumber, true);
					this.$refs.rejectReason.close();
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import '~@/assets/style/theme'
	
		.refund-verify {
			padding: 20px;
			
			.address {
				font-size: 13px;
				
				b {
					margin-right: 4px;
					color: #f00;
				}
				
				a {
					margin-left: 15px;
					color: #003DD9;
				}
			}
			
			.c-radio-group {
				margin: 20px 0;
			}
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 120px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
</style>